import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import CupsIcon from "../../../../../media/images/icons/cupsicon.png";
import { Link } from "react-router-dom";
import ArrowTickLeft from "../../../../../media/images/icons/arrow-tick-left";

export default function BannerBox() {
  return (
    <Box
      sx={{
        backgroundColor: "secondary.dark",
        height: "100px",
        borderRadius: "16px",
        width: "100%",
      }}
    >
      <Grid
        container
        sx={{
          height: "100%",
        }}
      >
        <Grid
          item
          xs={4}
          sx={{
            // border: "1px solid gray",
            height: "100%",
            backgroundImage: `url(${CupsIcon})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "120px",
            backgroundPosition: "80% 0%",
          }}
        ></Grid>
        <Grid
          item
          xs={8}
          sx={{
            // border: "1px solid gray",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            paddingY: "8px",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              color: "#fff",
            }}
          >
            کارن کلاب
          </Typography>
          <Typography
            sx={{
              color: "#fff",
            }}
          >
            باشگاهی مخصوص بازارگاه کارن ترابرنت
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Link
              to={"#"}
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#FFD54F",
                padding: "4px 8px",
                borderRadius: "4px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "600",
                  color: "#424242",
                }}
              >
                جوایز
              </Typography>
              <ArrowTickLeft size={18} color="#424242" />
            </Link>
            <Link
              to={"#"}
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#FFD54F",
                padding: "4px 8px",
                borderRadius: "4px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "600",
                  color: "#424242",
                }}
              >
                ماموریت‌ها
              </Typography>
              <ArrowTickLeft size={18} color="#424242" />
            </Link>
            <Link
              to={"#"}
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fff",
                padding: "4px 8px",
                borderRadius: "4px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "600",
                  color: "#424242",
                }}
              >
                راهنما
              </Typography>
              <ArrowTickLeft size={18} color="#424242" />
            </Link>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
